import { render, staticRenderFns } from "./MarketNews.vue?vue&type=template&id=11f39b29&scoped=true"
import script from "./MarketNews.vue?vue&type=script&lang=js"
export * from "./MarketNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f39b29",
  null
  
)

export default component.exports